function initTabsBlock() {
  const header = document.querySelector('header');
  const allTabsBlocks = document.querySelectorAll('.tabs-block');

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  allTabsBlocks.forEach(function (tabsBlock) {
    const navItems = tabsBlock.querySelectorAll('.tabs-block__nav-item');
    const tabPanels = tabsBlock.querySelectorAll('.tabs-block__tab-panel');
    const closeButton = tabsBlock.querySelector('.tabs-block__close-button');
    const contentBlock = tabsBlock.querySelector('.tabs-block__content');

    if (navItems.length === 0) return;

    // --- ZMIANA 1 ---
    // Funkcja otwierająca tab
    function switchTab(index) {
      closeAllTabs(); // Najpierw zamyka wszystko
      contentBlock.style.display = '';
      navItems[index].classList.add('is-active');
      if (tabPanels[index]) {
        tabPanels[index].classList.add('is-active');
      }
      // Dodaj blokadę przewijania na mobile
      if (window.innerWidth <= 789) {
        document.body.style.overflow = 'hidden';
      }
    }

    // --- ZMIANA 2 ---
    // Funkcja zamykająca taby
    function closeAllTabs() {
      navItems.forEach((item) => item.classList.remove('is-active'));
      tabPanels.forEach((panel) => panel.classList.remove('is-active'));
      contentBlock.style.display = 'none';
      // Zawsze usuwaj blokadę przewijania przy zamykaniu
      document.body.style.overflow = '';
    }

    function updateContentPosition() {
      if (header && contentBlock) {
        contentBlock.style.top = `${header.offsetHeight}px`;
      }
    }

    // --- ZMIANA 3 ---
    // Funkcja obsługująca resize i stan początkowy
    function handleResizeAndInitialState() {
      // updateContentPosition(); // Możesz odkomentować, jeśli jest potrzebne
      const isMobileView = window.innerWidth <= 789;

      if (isMobileView) {
        closeAllTabs();
      } else {
        // Upewnij się, że po przejściu na desktop scroll jest odblokowany
        document.body.style.overflow = '';

        const hasActiveTab = tabsBlock.querySelector(
          '.tabs-block__nav-item.is-active'
        );
        if (!hasActiveTab) {
          switchTab(0);
        }
      }
    }

    navItems.forEach((navItem, index) => {
      navItem.addEventListener('click', (e) => {
        e.preventDefault();
        const isActive = navItem.classList.contains('is-active');

        // Na mobile, kliknięcie aktywnego taba go zamyka (toggle)
        if (window.innerWidth <= 789 && isActive) {
          closeAllTabs();
        } else {
          switchTab(index);
        }
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        closeAllTabs();
      });
    }

    handleResizeAndInitialState();
    window.addEventListener(
      'resize',
      debounce(handleResizeAndInitialState, 150)
    );
  });
}

document.addEventListener('DOMContentLoaded', () => {
    initTabsBlock();

    const params = new URLSearchParams(window.location.search);
    const targetId = params.get('tabs-id');

    if (targetId) {
        const targetBtn = document.getElementById(targetId);
        if (targetBtn) {
            targetBtn.click();
        }
    }
});


if (typeof acf !== 'undefined') {
  acf.addAction('ready', (el) => {
    initTabsBlock(el);
  });
  acf.addAction('append', (el) => {
    initTabsBlock(el);
  });
}
